/**
 * Transform cluster coordinates - flip Y axis based on image height
 */
export const transformClusterCoords = (clusters, imageHeight) =>
  clusters.map(cluster => {
    return {
      ...cluster,
      border: cluster.border.map(([x, y]) => [x, imageHeight - y])
    }
  })

/**
 * Check if clusters have annotations of specific type
 */
export const hasAnnotationsOfType = (clusters, annotationType) => {
  if (!clusters?.length) return false

  const hasTextAnnotations = clusters.some(c => c.clusterType === 'annotation' && c.attributes?.blockType !== 'object')

  const hasObjectAnnotations = clusters.some(
    c => c.clusterType === 'annotation' && c.attributes?.blockType === 'object'
  )

  switch (annotationType) {
    case 'both':
      return hasTextAnnotations || hasObjectAnnotations
    case 'text':
      return hasTextAnnotations
    case 'object':
      return hasObjectAnnotations
    default:
      return false
  }
}
